import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

interface RevealProps {
  open: boolean
  children: ReactNode
  className?: string
}

/**
 * The one sanctioned size animation: a validation message (or any short line) grows
 * under its field over 200 ms through grid-template-rows (motion.css `band-grow`), and
 * collapses the same way. Stays mounted so the exit animates; `inert` while closed so
 * nothing hidden can be focused or read.
 */
export function Reveal({ open, children, className }: RevealProps) {
  return (
    <div className={cn('band-grow', className)} data-open={open} aria-hidden={!open} inert={!open}>
      <div>{children}</div>
    </div>
  )
}
